import { render, staticRenderFns } from "./modelTableEditorNative.vue?vue&type=template&id=1dfc903c&scoped=true&"
import script from "./modelTableEditorNative.vue?vue&type=script&lang=js&"
export * from "./modelTableEditorNative.vue?vue&type=script&lang=js&"
import style0 from "./modelTableEditorNative.vue?vue&type=style&index=0&id=1dfc903c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfc903c",
  null
  
)

export default component.exports